import { useEcosystemAuth } from './useEcosystemAuth';

// Ecosystem auth ALWAYS connects to the central FreedomForge project
// (uefznzzkrzqxgxxwslox). Per-site env (REACT_APP_SUPABASE_URL) points at
// the per-site Oasara project for non-auth data and must NOT be used here.
// Anon keys are public per Supabase docs. May 4 Unified Auth Board fix —
// Oasara was missed in the original migration. Applied 2026-05-11.
const config = {
  supabaseUrl: 'https://uefznzzkrzqxgxxwslox.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVlZnpuenprcnpxeGd4eHdzbG94Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYyNDIzODQsImV4cCI6MjA3MTgxODM4NH0.YmwwuEhG7Siv8zyL9XFjthNuqJrST3C4hs3qESb-grM',
  siteKey: 'oasara',
  siteName: 'OASARA',
  redirectUrl: `${typeof window !== 'undefined' ? window.location.origin : 'https://oasara.com'}/auth/confirm`,
};

export function useOasaraAuth() {
  return useEcosystemAuth(config);
}
